import { api } from 'data/api/api'
import { moneyObjectHeader } from 'data/api/money-object-header'

import { ClosetPromoPerfrmanceResponse } from '../types/closet-promo-performance'
import { GetClosetPromotionArgs, PromotedClosetsListResp } from '../types/closet-promotions'
import { getClosetPromotionsArgsToParams } from '../transformers/closet-promotions'

export const getClosetPromotionPerformance = () =>
  api.get<ClosetPromoPerfrmanceResponse>('promoted_closets/performances')

export const getClosetPromotions = (args: GetClosetPromotionArgs) =>
  api.get<PromotedClosetsListResp>('/promoted_closets', {
    params: getClosetPromotionsArgsToParams(args),
    headers: moneyObjectHeader,
  })
